module.exports = __webpack_public_path__ + "img/全网亿级流量@2x.b30d3b00.png";